import React from 'react'
import { MdOutlineClose } from "react-icons/md";

const ViewModal = ({ data, onClose }) => {
  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-md w-[90%] max-w-[1000px]">
          <div className="flex justify-between items-center mb-4 border-b pb-3">
            <h2 className="text-xl font-semibold text-gray-800">Details</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-red-500">
              <MdOutlineClose className='w-9 h-9 bg-gray-100 rounded-full p-1' />
            </button>
          </div>

          <div className='grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-3'>
            <div>
              <lable className='block text-sm font-medium text-black'>Name:</lable>
              <input disabled type="text" id="l_name" name='l_name' value={data?.name || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm capitalize" />
            </div>
            <div>
              <lable className='block text-sm font-medium text-black'>User Name:</lable>
              <input disabled type="text" id="l_name" name='l_name' value={data?.user_name || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm capitalize" />
            </div>
            <div>
              <lable className='block text-sm font-medium text-black'>Email:</lable>
              <input disabled type="text" id="l_name" name='l_name' value={data?.email || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <lable className='block text-sm font-medium text-black'>Phone:</lable>
              <input disabled type="text" id="l_name" name='l_name' value={data?.phone || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <lable className='block text-sm font-medium text-black'>Status:</lable>
              <input disabled type="text" id="l_name" name="l_name" value={data.admin_type} className={`w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm ${data.status === "Expired" ? "text-red-500" : data.admin_type === "Active" ? "text-green-500" : "text-yellow-600"}`} />
            </div>
            <div>
              <lable className='block text-sm font-medium text-black'>Admin Type:</lable>
              <input disabled type="text" id="l_name" name='l_name' value={data?.admin_type || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <lable className='block text-sm font-medium text-black'>Access:</lable>
              <input disabled type="text" id="l_name" name='l_name' value={data?.access || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewModal